<app-details-historie-card
  testId="tdb-details-historie"
  [subtitle]="'testdatenblaetter.form.historie.subtitle' | translate"
  [tabs]="reiter()"
  [(activeTab)]="aktiverReiter"
>
  <ng-template appDetailsHistoriePanel="uebergabe">
    <app-uebergabe-panel
      testIdPrefix="tdb-handover"
      [messageRequired]="true"
      [skipAllowed]="true"
      [chain]="stufen()"
      [closed]="kette()?.closed ?? false"
      [closedAt]="kette()?.closedAt ?? null"
      [activeSince]="seit()"
      [vorlagen]="vorlagen()"
      [personOptions]="auswahl()"
      [readonly]="readonly()"
      [disabledReason]="sperrGrund()"
      [handOffDisabledReason]="uebergebenSperrGrund()"
      [busy]="beschaeftigt()"
      [errorMessage]="aktionsFehler()"
      [status]="ketteStatus()"
      [entwurf]="entwurf()"
      (entwurfChange)="entwurfGeaendert($event)"
      (handOff)="uebergeben($event)"
      (close)="abschliessen()"
      (reopen)="wiederOeffnen()"
      (skip)="ueberspringen($event)"
      (retry)="ladeKette()"
    />
  </ng-template>
  <ng-template appDetailsHistoriePanel="verlauf">
    <app-verlauf-liste [eintraege]="verlaufEintraege()" [status]="verlaufStatus()" (retry)="ladeVerlauf()" />
  </ng-template>
  <ng-template appDetailsHistoriePanel="notizen">
    <div class="tdb-notizen">
      <textarea
        class="tdb-notizen__field"
        rows="3"
        data-testid="tdb-notes"
        [formControl]="notesControl()"
        [attr.aria-label]="'testdatenblaetter.form.historie.notesLabel' | translate"
        [attr.maxlength]="maxNotes"
        [placeholder]="'testdatenblaetter.form.historie.notesPlaceholder' | translate"
      ></textarea>
      <div class="tdb-notizen__counter" data-testid="tdb-notes-counter" aria-live="polite">
        {{ notes().length }} / {{ maxNotes }}
      </div>
    </div>
  </ng-template>
</app-details-historie-card>
